// ---------------------------------------------------------------------------
// sentry.ts — Dashboard Sentry initialization
//
// Side-effect module: importing this file calls Sentry.init(). Must be
// imported early in the application entry point (main.tsx).
//
// Configuration:
//   - DSN from VITE_SENTRY_DSN environment variable
//   - Release tagged with VITE_BUILD_ID (set by vite.config.ts define)
//   - 10% trace sampling
//   - BrowserTracing integration for performance monitoring
//
// Restored at apps/dashboard/src/sentry.ts after the legacy repo-root
// src/sentry.ts was removed; main.tsx imports from this path.
// ---------------------------------------------------------------------------

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  release: import.meta.env.VITE_BUILD_ID,
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration()],
});
